function fnStats(i, oSection) {
	gsap.context(() => {
		gsap.from('.item', {
			x: '100%',
			stagger: .15,
			ease: 'none',
			scrollTrigger: {
				trigger: oSection,
				start: 'top 90%',
				end: 'bottom bottom',
				scrub: true
			}
		})
	}, oSection)
	
}
